export const getContactDetailsActive = (state) => {
  return state.ui.conversation.contactDetailsActive;
};
export const getMessagesActive = (state) => {
  return state.ui.conversation.messagesActive;
};

export const getChatHeadActive = (state) => {
  return state.ui.conversation.chatHeadActive;
};
export const getShowNavBarBack = (state) => {
  return (
    state.ui.conversation.messagesActive ||
    state.ui.conversation.contactDetailsActive
  );
};
